class Client {
    id = null;
    name = '';
    sport_center_name = '';
    oib = '';
    hash = '';
    valid_until = null;
    api_token = '';
    plus = false;
    discount = 0;
    official_email = '';
    financial_status_id = 1;
    notification_limit = 500;
    intis_enabled = false;
    intis_reader_types = [];
    intis_gate_ids = [];
    intis_relay = '0.1';
    intis_activation_time = 15;
    stripe_enabled = false;
    payment_plans_enabled = false;
    nuki_enabled = false;
    nuki_api_token = '';
    nuki_lock_id = '';
    automatic_member_entries = true;
    latitude = '';
    longitude = '';

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default Client;